export const REFRESH = {
  REFRESH_PAGE: 'REFRESH_PAGE',
};
